<ng-content></ng-content> <span *ngIf="isRequired" class="required">*</span>
